export const config = {
  title:
    'Let’s calculate an accurate cost and required resources for your project',
  businessDomain: {
    name: 'businessDomain',
    placeholder: 'Your business domain',
  },
  briefOverview: {
    textareaLabel: 'Please provide a brief overview of the development project',
    textarea: {
      name: 'overview',
      id: 'overview',
      placeholder:
        'For example, CRM Development for Household Appliances Manufacturer…',
    },
  },
  inputs: [
    {
      id: 1,
      input: {
        name: 'name',
        placeholder: 'Name',
        id: 'name',
      },
      label: 'Your name',
    },
    {
      id: 2,
      input: {
        name: 'email',
        placeholder: 'E-mail',
        id: 'email',
      },
      label: 'E-mail',
    },
  ],
  platformsLabel: 'Which type of software solution is planned',
  platforms: ['Desktop', 'Mobile', 'Web'] as const,
  platformsError: 'Type of software solution is a required field',
  submitButton: 'Send',
  submittedText:
    'Thanks for your interest.\nOur team will contact you soon.\nHave a nice day!',
}
